import {
  actasNotificador,
  getActasNotificador,
  getMotivos,
  notificar,
  reportarNoNotificada,
  reporteNotificadores
} from "../services";
import { useNotificadoresStore } from "../store/notificadoresStore";

const { setActas, setMotivos, setPaginateCfg, setReporteNotificador, setActasSeleccionadas,setSubmitFilter } =
  useNotificadoresStore.getState();

export const getActas = async (payload, params) => {
  const result = await actasNotificador(payload, params);
  if (result) {
    setActas(result);
    const { data, ...paginado } = result;
    setPaginateCfg({ ...paginado });
  }
  // const result = await getActasNotificador();
};

export const getMotivosReporte = async () => {
  const result = await getMotivos();
  setMotivos(result);
};

export const reportarActa = async (payload, setRefetch) => {
  let formData = new FormData();
  formData.append("acta_id", payload.id);
  formData.append("latitud", payload.ubicacion[0]);
  formData.append("longitud", payload.ubicacion[1]);
  formData.append("motivo_id", payload.motivo_id);
  formData.append("observacion", payload.observacion);
  formData.append("estado_id", 9);
  formData.append("accion", payload.accion);

  if (payload.array_ids && Array.isArray(payload.array_ids)) {
    payload.array_ids.forEach((id) => {
      formData.append("array_ids[]", id);
    });
  }

  if (payload.motivoManual) {
    formData.append("motivo_manual", payload.motivoManual);
  }

  if (payload.archivo) {
    formData.append("file", payload.archivo[0]);
  }

  const config = {
    headers: { "content-type": "multipart/form-data" },
  };

  //  formData.append("acta_id", dataSend.id);
  //  formData.append("latitud", dataSend.latitud);
  //  formData.append("longitud", dataSend.longitud);
  //  formData.append("motivo_id", dataSend.motivo_id);
  //  formData.append("observacion", dataSend.observacion);

  //  if (dataSend.archivo) {
  //    formData.append("archivo", dataSend.archivo[0]);
  //  }

  payload.archivo = payload.archivo[0];

  // export const onSubmitNoNotificada = async (formActa, setActas, reset, setIsLoading, row, setRow, setIsLoadingModal, location, setLocation, archivo, setShowModalMotivo) => {

  //   let formData = new FormData();    //formdata object
  //   formData.append('acta_id', row.id);   //append the values with key, value pair
  //   formData.append('latitud', location.latitude);
  //   formData.append('longitud', location.longitude);
  //   formData.append('motivo_id', formActa.motivo);
  //   formData.append('observacion', formActa.observacion);
  //   formActa.motivoManual && formData.append('motivo_manual', formActa.motivoManual);

  //   formData.append('file', archivo);

  //   const config = {
  //     headers: { 'content-type': 'multipart/form-data' }
  //   }

  //   const response = await axios().post("no_notificada", formData, config);
  //   const { data, error } = response.data;

  //   setIsLoadingModal(false);

  //   if (data) {
  //     toast.success("Información cargada", toastOptions);
  //     setRow(null);
  //     reset();
  //     setShowModalMotivo(false);
  //     setLocation(null);

  //     setIsLoading(true);
  //     const result = await axios().get("/get_actas_notificador");
  //     const { data, error } = result.data;

  //     setIsLoading(false);

  //     if (data) {
  //       setActas(data);
  //     }

  //     if (error) {
  //       toast.error(error, toastOptions);
  //     }

  //     return;
  //   }

  //   if (error) {
  //     toast.error(error, toastOptions);
  //     return;
  //   }

  // };
  const { actas } = useNotificadoresStore.getState();
  // const result = await reportarNoNotificada(payload);
  const result = await reportarNoNotificada(formData, config);
  if (result) {
    setActasSeleccionadas(null);
    setRefetch(true);
    // const newActas = actas.filter((acta) => acta.id != payload.id);
    // setActas(newActas);
  }
};

export const notificarActa = async (payload, setRefetch) => {
  const { actas } = useNotificadoresStore.getState();
  const result = await notificar(payload);
  if (result) {
    setActasSeleccionadas(null);
    setRefetch(true);
  }
};

export const reporteNotificadoresHandler = async (payload, setRefetch) => {
  const result = await reporteNotificadores(payload);
  if (result) {
    setReporteNotificador(result);
    setSubmitFilter(false)
    // setRefetch(true);
  }
};
